function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useRef, useEffect, useCallback, useContext } from 'react';
import { useSelector } from 'react-redux';
import Sortable from 'sortablejs';
import { v4 as uuid } from 'uuid';
import { useTranslation } from 'react-i18next';
import { ActionButton, createTree, MousePositionedTooltip } from '@keen.io/ui-core';
import { useSearch } from '@keen.io/react-hooks';
import { BodyText } from '@keen.io/typography';
import { colors } from '@keen.io/colors';
import { PropertySettings, SortableContainer, Wrapper } from './ExtractionProperties.styles';
import ExtractionTitle from '../ExtractionTitle';
import SearchableProperty from '../../../SearchableProperty';
import { AppContext, SearchContext } from '../../../../contexts';
import { getCollectionSchema } from '../../../../modules/events';
import { mutateArray } from '../../../../utils';
import { DRAG_ANIMATION_TIME } from './constants';

var ExtractionProperties = function ExtractionProperties(_ref) {
  var properties = _ref.properties,
      collection = _ref.collection,
      onSetProperties = _ref.onSetProperties;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useContext = useContext(AppContext),
      modalContainer = _useContext.modalContainer;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      propertiesTree = _useState2[0],
      setPropertiesTree = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      searchPropertiesPhrase = _useState4[0],
      setSearchPhrase = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      expandTree = _useState6[0],
      setTreeExpand = _useState6[1];

  var propertiesRef = useRef(null);
  propertiesRef.current = properties;

  var _useSelector = useSelector(function (state) {
    return getCollectionSchema(state, collection);
  }),
      schemaTree = _useSelector.tree,
      schemaList = _useSelector.list;

  var _useSearch = useSearch(schemaList, function (searchResult, phrase) {
    if (phrase) {
      var searchTree = {};
      searchResult.forEach(function (_ref2) {
        var path = _ref2.path,
            type = _ref2.type;
        searchTree[path] = type;
      });
      setSearchPhrase(phrase);
      setPropertiesTree(createTree(searchTree));
      setTreeExpand(true);
    } else {
      setTreeExpand(false);
      setPropertiesTree(null);
    }
  }, {
    keys: ['path', 'type'],
    threshold: 0.4
  }),
      searchHandler = _useSearch.searchHandler;

  var clearSearchHandler = useCallback(function () {
    setPropertiesTree(null);
    setSearchPhrase(null);
  }, []);
  var updateProperty = useCallback(function (propertySettings) {
    var propertiesSettings = properties.map(function (property) {
      if (property.id === propertySettings.id) return propertySettings;
      return property;
    });
    onSetProperties(propertiesSettings);
  }, [properties, onSetProperties]);
  var removeProperty = useCallback(function (id) {
    var propertiesSettings = properties.filter(function (property) {
      return property.id !== id;
    });
    if (propertiesSettings.length === 0) propertiesSettings = undefined;
    onSetProperties(propertiesSettings);
  }, [properties, onSetProperties]);
  var sortableRef = useRef(null);

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isDragged = _useState8[0],
      setDragMode = _useState8[1];

  useEffect(function () {
    var dragGhost;
    new Sortable(sortableRef.current, {
      animation: DRAG_ANIMATION_TIME,
      filter: '.add-button',
      handle: '.drag-handle',
      onStart: function onStart() {
        setDragMode(true);
        setTreeExpand(false);
      },
      onMove: function onMove(evt) {
        return !evt.related.className.includes('add-button');
      },
      onEnd: function onEnd(evt) {
        var updatedGroups = mutateArray(propertiesRef.current, evt.oldIndex, evt.newIndex);
        onSetProperties(updatedGroups);
        setDragMode(false);
        if (dragGhost) dragGhost.parentNode.removeChild(dragGhost);
      },
      setData: function setData(dataTransfer, dragEl) {
        dragGhost = dragEl.cloneNode(true);
        var styles = {
          width: dragEl.offsetWidth,
          transform: 'translateX(-100%)',
          position: 'absolute'
        };
        Object.assign(dragGhost.style, styles);
        var tree = dragGhost.querySelector('[data-testid="properties-tree"]');
        if (tree) tree.remove();
        document.body.appendChild(dragGhost);
        dataTransfer.setDragImage(dragGhost, 10, 10);
      }
    });
  }, []);

  var selectEventStreamTooltip = function selectEventStreamTooltip() {
    return React.createElement(BodyText, {
      variant: "body2",
      fontWeight: "normal",
      color: colors.white[500]
    }, t('query_creator_extraction_properties.select'), ' ', React.createElement("strong", null, t('query_creator_extraction_properties.event_stream')), ' ', t('query_creator_extraction_properties.tooltip'));
  };

  return React.createElement("div", null, React.createElement(ExtractionTitle, {
    isDisabled: !collection,
    isFullExtraction: properties.length === 0,
    onClearProperties: function onClearProperties() {
      return onSetProperties(undefined);
    }
  }), React.createElement(Wrapper, null, React.createElement(SearchContext.Provider, {
    value: {
      expandTree: expandTree,
      searchPropertiesPhrase: searchPropertiesPhrase
    }
  }, React.createElement(SortableContainer, {
    ref: sortableRef
  }, properties.map(function (_ref3) {
    var id = _ref3.id,
        propertyName = _ref3.propertyName;
    return React.createElement(PropertySettings, {
      key: id,
      "data-testid": "extraction-settings-item"
    }, React.createElement(SearchableProperty, {
      isEditAllowed: !isDragged,
      properties: propertiesTree ? propertiesTree : schemaTree,
      property: propertyName,
      onSearchProperties: searchHandler,
      onSelectProperty: function onSelectProperty(propertyName) {
        clearSearchHandler();
        updateProperty({
          id: id,
          propertyName: propertyName
        });
      },
      onBlur: function onBlur() {
        if (!propertyName) removeProperty(id);
      },
      onRemove: function onRemove() {
        clearSearchHandler();
        removeProperty(id);
      }
    }));
  }), React.createElement(MousePositionedTooltip, {
    isActive: !collection,
    tooltipTheme: "dark",
    tooltipPortal: modalContainer,
    renderContent: selectEventStreamTooltip
  }, React.createElement(ActionButton, {
    className: "add-button",
    isDisabled: !collection,
    action: "create",
    onClick: function onClick() {
      var property = {
        id: uuid(),
        propertyName: ''
      };
      onSetProperties([].concat(_toConsumableArray(properties), [property]));
    }
  }))))));
};

export default ExtractionProperties;